import React from 'react';
import { campaignEditorInitialState } from './campaignEditorInitialState';
import { CampaignEditorReducer } from './CampaignEditorReducer';
import { CampaignEditorDispatch, CampaignEditorState } from './CampaignEditorState';

const CampaignEditorContext = React.createContext<
  { state: CampaignEditorState; dispatch: CampaignEditorDispatch } | undefined
>(undefined);

function CampaignEditorProvider(props) {
  const [state, dispatch] = React.useReducer(CampaignEditorReducer, campaignEditorInitialState);
  const value = { state, dispatch };
  return <CampaignEditorContext.Provider value={value} {...props} />;
}

function useCampaignEditorContext() {
  const context = React.useContext(CampaignEditorContext);

  if (!context) {
    throw new Error(`useCampaignEditorContext must be used within a CampaignEditorProvider`);
  }

  return context;
}

export { CampaignEditorProvider, useCampaignEditorContext };
